import React from 'react'
import { Box } from '@mui/material'
import Header from 'components/common/SevenScreenHeader/Header'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
    screenWrapper: {
        width: '100%',
        height: '100%',
    },
    screenContentWrapper: {
        backgroundImage: 'linear-gradient(to bottom, #00599B, #002D4E)',
        color: '#fff',
        width: '100%',
        height: 'calc(100% - 83px)',
        textAlign: 'center',
        alignContent: 'center',
    },
})

const Screen5 = () => {
    const classes = useStyles()
    return (
        <Box className={classes['screenWrapper']}>
            <Header title="Screen 5" />
            <main className={classes['screenContentWrapper']}>Screen 5 </main>
        </Box>
    )
}

export default Screen5
